var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-loader-background",style:({ 'background-image': `url(${_vm.resourceUrl(_vm.backgroundLoaderUrl)})` })},[_c('div',{staticClass:"organism-loader-gradient"}),_vm._v(" "),_c('AtomsCommonAtomLoadingError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }